import styled from 'styled-components';

import { VFlex } from '@/components/base';
import { customScrollbar } from '@/styles/style';

export const SidebarContainer = styled(VFlex)`
  height: 100%;
  background-color: ${(props) => props.theme.colors.gray100};
  border-right: 1px solid ${(props) => props.theme.colors.gray250};
`;

export const TreeContainer = styled(VFlex)`
  padding: 0 calc(28px - 16px) 32px 28px;
  overflow: auto;
  flex: 1;
  scrollbar-gutter: stable;
  ${customScrollbar};
`;
